import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
Swiper.use([Navigation, Pagination]);

import "swiper/swiper-bundle.css";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// slider

var swiperContainer = document.querySelector(".swiper-container");
if (swiperContainer) {
  const swiper = new Swiper(swiperContainer, {
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
    navigation: {
      nextEl: ".carousel-next",
      prevEl: ".carousel-prev",
    },
  });
}

// burger menu

var button = document.querySelector(".header-nav-mobile-button");
var menu = document.querySelector(".header-nav-mobile-link");
var body = document.querySelector("body");

var openMenu = function () {
  menu.classList.toggle("is-open");
  body.classList.toggle("is-blocked");
};

if (button) {
  button.addEventListener("click", openMenu);
}

var scrollTrigger = document.getElementById("scroll-trigger");
if (scrollTrigger) {
  scrollTrigger.addEventListener("click", function () {
    // Effectuez un défilement de 100vh
    window.scrollBy(0, window.innerHeight);
  });
}

// nav

window.addEventListener("DOMContentLoaded", () => {
  const nav = document.querySelector(".header-nav-desktop");
  if (nav) {
    const navHeight = nav.offsetHeight;
    document.body.style.paddingTop = `${navHeight}px`;
  }
});
